import React from "react";
import BlogThree from "../component/BlogThree";

function BlogThreeContainer() {
  return <BlogThree />;
}
export default BlogThreeContainer;
